module.exports = "<span (click)=\"closePopup()\" class=\"close\"></span>\n<div #popupContent>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/historic/mobile-popup/mobile-popup.component.html
// module id = ./src/app/historic/mobile-popup/mobile-popup.component.html
// module chunks = main